// VinCentrix usability layer: keep the acquisition workspace focused on the next action.
// This intentionally changes hierarchy/copy, not the established VinCentrix visual identity.
const STYLE_ID='vc-usability-simplification-styles';
let workspaceSeen=null;

const ensureStyles=()=>{
  if(document.getElementById(STYLE_ID))return;
  const s=document.createElement('style');s.id=STYLE_ID;s.textContent=`
    .vc-acquisition-workspace .vc-next-action-panel{border-color:rgba(34,211,238,.32)!important;background:linear-gradient(135deg,rgba(8,30,48,.96),rgba(7,17,31,.98))!important;box-shadow:0 10px 34px rgba(6,182,212,.10)!important}
    .vc-opportunity-drawer>div:first-child{position:sticky;top:0;z-index:12;background:linear-gradient(180deg,#07101f 82%,rgba(7,16,31,.94));padding-top:4px;margin-top:-4px}
    .vc-opportunity-drawer .vc-next-action-panel{position:relative;z-index:2}
    @media(max-width:768px){
      .vc-acquisition-workspace{padding-bottom:72px}.vc-acquisition-header{padding:16px!important;border-radius:16px!important;margin-bottom:12px!important}
      .vc-acquisition-header h2{font-size:22px!important}.vc-acquisition-header p{font-size:11px!important;margin-top:5px!important}
      .vc-acquisition-actions{grid-template-columns:1fr 1fr 1fr!important;gap:7px!important}.vc-acquisition-actions button{padding:10px 8px!important;font-size:11px!important}
      .vc-opportunity-drawer{padding:14px!important}.vc-opportunity-drawer>div:first-child{margin:-2px -2px 0;padding:4px 2px 13px}
      .vc-opportunity-drawer .vc-next-action-panel{margin:10px 0!important}
    }
    @media(min-width:769px){.vc-acquisition-header{padding:22px 26px!important}.vc-opportunity-drawer .vc-next-action-panel{margin:14px 0!important}}
  `;document.head.appendChild(s);
};

const replaceExactText=(root,from,to)=>{
  [...root.querySelectorAll('div,h1,h2,h3,p,span,button')].forEach(el=>{
    if(el.children.length===0 && (el.textContent||'').trim()===from)el.textContent=to;
  });
};

const simplifyWorkspace=ws=>{
  if(!ws)return;
  const header=ws.querySelector('.vc-acquisition-header');
  if(header){
    replaceExactText(header,'VinCentrix Acquisition CRM','ACQUISITION WORKSPACE');
    replaceExactText(header,'Acquisition Pipeline','Opportunities');
    replaceExactText(header,'Work every vehicle from first opportunity through purchase.','Everything you need to move the next vehicle toward acquisition.');
    replaceExactText(header,'Customers','List');
  }

  // Default to the easier list view once per mounted workspace. Pipeline remains one tap away.
  if(workspaceSeen!==ws){
    workspaceSeen=ws;
    const buttons=[...ws.querySelectorAll('.vc-acquisition-actions button')];
    const list=buttons.find(b=>/^(customers|list)$/i.test((b.textContent||'').trim()));
    if(list) requestAnimationFrame(()=>list.click());
  }
};

const simplifyDrawer=drawer=>{
  if(!drawer)return;
  replaceExactText(drawer,'Purchased For','Agreed Purchase Price');
  const next=drawer.querySelector('.vc-next-action-panel');
  if(next){
    const label=[...next.querySelectorAll('div')].find(el=>el.children.length===0 && /current acquisition workflow/i.test(el.textContent||''));
    if(label)label.textContent='WHAT TO DO NEXT';
  }
};

const scan=()=>{ensureStyles();simplifyWorkspace(document.querySelector('.vc-acquisition-workspace'));simplifyDrawer(document.querySelector('.vc-opportunity-drawer'));};
const boot=()=>{scan();new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
